<template>
  <b-modal
    ref="modal-view"
    id="modal-view"
    title="Detail Employee"
    centered
    hide-footer
    hide-header
  >
    <div class="p-3">
      <div class="d-flex justify-content-between align-items-start mb-3">
        <h4><b>Detail Employee</b></h4>
        <img
          class="pointer"
          src="@/assets/btn-close.png"
          alt=""
          @click="$bvModal.hide('modal-view')"
        />
      </div>
      <b-form-group label="" label-size="sm" label-class="font-weight-bold">
        <div :style="{ color: '#00B4A5' }">
          {{ !employee.is_contractor ? "Internal ITM Group" : "Contractor" }}
        </div>
      </b-form-group>
      <b-form-group
        label="Username"
        label-size="sm"
        label-class="font-weight-bold"
      >
        <b-form-input
          autocapitalize="off"
          v-model="employee.username"
          disabled
        />
      </b-form-group>
      <b-form-group
        label="Employee Name"
        label-size="sm"
        label-class="font-weight-bold"
      >
        <b-form-input
          autocapitalize="off"
          v-model="employee.fullname"
          disabled
        />
      </b-form-group>
      <b-form-group label="Role" label-size="sm" label-class="font-weight-bold">
        <b-form-input autocapitalize="off" v-model="roleName" disabled />
      </b-form-group>
      <b-form-group
        label="Division"
        label-size="sm"
        label-class="font-weight-bold"
      >
        <b-form-input
          autocapitalize="off"
          v-model="divisionName"
          disabled
        />
      </b-form-group>
      <b-form-group
        label="Department"
        label-size="sm"
        label-class="font-weight-bold"
      >
        <b-form-input
          autocapitalize="off"
          v-model="employee.department"
          disabled
        />
      </b-form-group>
      <b-form-group
        label="Company"
        label-size="sm"
        label-class="font-weight-bold"
      >
        <b-form-input autocapitalize="off" v-model="companyName" disabled />
      </b-form-group>
      <b-form-group
        label="Contractor"
        v-show="employee.contractors"
        label-size="sm"
        label-class="font-weight-bold"
      >
        <b-form-input autocapitalize="off" v-model="contractorName" disabled />
      </b-form-group>
      <b-form-group
        label="Email"
        label-size="sm"
        label-class="font-weight-bold"
      >
        <b-form-input autocapitalize="off" v-model="employee.email" disabled />
      </b-form-group>
      <b-form-group
        label="Phone Number"
        label-size="sm"
        label-class="font-weight-bold"
      >
        <b-form-input autocapitalize="off" v-model="employee.phone" disabled />
      </b-form-group>
      <div class="d-flex justify-content-end align-items-center mt-5">
        <b-button v-if="canEdit" class="btn-reset" variant="outline-info" @click="reset">
          Reset Password
        </b-button>
        <b-button v-if="canEdit" class="btn-custom ml-2 " variant="info" @click="onClickEdit">
          Edit
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { hasPermission } from '@/utils/permissions'
import { EMPLOYEE_EDIT } from '@/fixtures'

export default {
  computed: {
    contractorName: {
      get() {
        if (this.employee.contractors) {
          return this.employee.contractors.name
        } else {
          return ' '
        }
      }
    },
    roleName: {
      get() {
        if (this.employee.roles) {
          return this.employee.roles.name
        } else {
          return ' '
        }
      }
    },
    companyName: {
      get() {
        if (this.employee.company) {
          return this.employee.company.name
        } else {
          return ' '
        }
      }
    },
    divisionName() {
      if (this.employee.division) {
        return this.employee.division.name
      } else {
        return ' '
      }
    }
  },
  props: {
    employee: {
      types: Object,
      default: () => ({})
    }
  },
  data: () => ({
    canEdit: hasPermission(EMPLOYEE_EDIT),
    profile: JSON.parse(localStorage.getItem('profile'))
  }),
  methods: {
    onClickEdit() {
      this.$bvModal.hide('modal-view')
      this.$emit('editData', this.employee)
    },
    reset() {
      this.$emit('reset', this.employee.id)
      this.$bvModal.hide('modal-view')
    }
  }
}
</script>
